import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class AlfredA2Service {

    constructor(private http : Http) {}

    getCountries(){
        return this.http
            .get(`../rest/alfred/country`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    getCreditCards(countryCode){
        return this.http
            .get(`../rest/alfred/creditCard/${countryCode}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/core/alfred.service.ts